/** Ids 63/64/65 are stored in JSON as 5X, 10X, 3X — sort for dropdown as 3 → 5 → 10. */
const CREDIT_ID_DISPLAY_ORDER = new Map([
  [65, 0],
  [63, 1],
  [64, 2],
]);

/**
 * Puts non-credit rows first (original order), then 3X, 5X, 10X — so the list does not read as "5, 10, 3".
 */
export function sortAccountTypesForSelect(items) {
  if (!Array.isArray(items)) return [];
  return [...items].sort((a, b) => {
    const idA = Number(a?.Id);
    const idB = Number(b?.Id);
    const ordA = CREDIT_ID_DISPLAY_ORDER.has(idA)
      ? CREDIT_ID_DISPLAY_ORDER.get(idA)
      : null;
    const ordB = CREDIT_ID_DISPLAY_ORDER.has(idB)
      ? CREDIT_ID_DISPLAY_ORDER.get(idB)
      : null;
    const creditA = ordA !== null;
    const creditB = ordB !== null;
    if (creditA && creditB) return ordA - ordB;
    if (creditA && !creditB) return 1;
    if (!creditA && creditB) return -1;
    return 0;
  });
}

/**
 * Display labels for the account type select (Standard; credit tiers as 3X/5X/10X Credit).
 * Values remain item.Id; only the visible text changes.
 */
export function formatAccountTypeSelectLabel(item) {
  const id = Number(item?.Id);
  if (id === 65) return "3X Credit";
  if (id === 63) return "5X Credit";
  if (id === 64) return "10X Credit";
  const label = String(item?.["Account type"] ?? "").trim();
  if (/^standard account$/i.test(label)) {
    return "Standard";
  }
  return item?.["Account type"] ?? "";
}
